import {
  COMPARE_PRODUCT_LOADED,
  COMPARE_PRODUCT_REMOVED,
  COMPARE_PRODUCT_URL_UPDATED,
} from '../constants';

const defaultState = {
  articles: [],
  comparePageUrl: '',
};

export const compare = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case COMPARE_PRODUCT_LOADED:
      return { ...state, ...payload };
    case COMPARE_PRODUCT_URL_UPDATED:
      return { ...state, ...payload };
    case COMPARE_PRODUCT_REMOVED: {
      const { articleNumber } = payload;
      const articles = state.articles ?? [];
      const _index = articles.findIndex(
        (a) => a.articleNumber === articleNumber
      );

      // remove from array
      if (_index !== -1) {
        articles.splice(_index, 1);
      }

      return { ...state, articles };
    }
    default:
      return state;
  }
};
